import type { DeepPartial } from '@luna/utils-ts';

import type { PaymentOrders } from './PaymentsOrders';

export const CZ: DeepPartial<PaymentOrders> = {
    signingExpirationCounter: {
        enabled: false,
    },
};
